import { moduleActionContext } from '.';
import { AutoFactory, OnlinePortalPersonaApi, PersonaSettingsInternal } from '@sageworks/jpi';
import { getOnlinePortalSubdomain } from '@/utils/UrlUtils';
import { defineModule } from 'direct-vuex';
import { UrlUtils } from '@/utils';
import { PersonaGenerateTokenInternal } from '@sageworks/jpi/src/auto-generated/model/personaGenerateTokenInternal';

const actionContext = (context: any) => moduleActionContext(context, PersonaModule);

export interface PersonaModuleState {
	settings: PersonaSettingsInternal | null;
}
const PersonaModule = defineModule({
	namespaced: true,
	state: () => {
		return {
			settings: null
		} as PersonaModuleState;
	},
	mutations: {
		SET_PERSONA_SETTINGS(state, settings: PersonaSettingsInternal) {
			state.settings = settings;
		}
	},
	actions: {
		async fetchPersonaSettings(context): Promise<void> {
			const { commit } = actionContext(context);
			const personaService = AutoFactory.get(OnlinePortalPersonaApi);
			const currentSubdomain = getOnlinePortalSubdomain();
			var keys = await personaService.getPersonaSettingsBySubdomain(currentSubdomain);
			commit.SET_PERSONA_SETTINGS(keys);
		},
		async generatePersonaIdentityToken(context, payload: { inquiryId: string; rememberThisDevice: boolean }): Promise<void> {
			const { rootState, rootCommit } = actionContext(context);
			const subdomain = UrlUtils.getOnlinePortalSubdomain();
			const username = rootState.Login.userEmail;
			const secret = rootState.Login.userPassword;

			try {
				const tokenResult = await AutoFactory.get(OnlinePortalPersonaApi).generateVerificationToken({
					subDomain: subdomain,
					username: username,
					secret: secret,
					inquiryId: payload.inquiryId
				} as PersonaGenerateTokenInternal);

				if (!tokenResult.identityVerified || !tokenResult.deviceToken) {
					throw new Error('Verification failed');
				}
				rootCommit.Authentication.SET_DEVICE_TOKEN({ deviceToken: tokenResult.deviceToken, rememberThisDevice: payload.rememberThisDevice });
			} catch (error) {
				throw new Error('Verification failed');
			}
		},
		async saveFailedPersonaVerification(context, payload: { inquiryId: string }): Promise<void> {
			const { rootState} = actionContext(context);
			const subdomain = UrlUtils.getOnlinePortalSubdomain();
			const username = rootState.Login.userEmail;
			const secret = rootState.Login.userPassword;
			const request = {
				subDomain: subdomain,
				username: username,
				secret: secret,
				inquiryId: payload.inquiryId
			} as PersonaGenerateTokenInternal;

			try {
				await AutoFactory.get(OnlinePortalPersonaApi).saveFailedVerification(request);
			} catch (error) {
				throw new Error('Failed to save verification');
			}	
		}
	}
});

export default PersonaModule;
